<script>
    import Project from "./Project.svelte";
    let projectTitle = "How I Built It";
    let projectDescription = "This website was built with Svelte.js. I used a helper project for routing called svelte-spa-router, which easilly allows for some simple hashtag routes. This project is hosted on Google Firesbase Hosting.";
</script>
<Project projectTitle = {projectTitle} projectDescription={projectDescription}>
    <section>
     <img src="images/site.png" alt="website showing blog post">
    </section>
</Project>
<style>
    section{
    justify-content: center;
    align-items: center;
    margin: auto;
    }
    img{max-width: 900px;
    }

    @media (max-width: 900px) {
       img{width:100vw;}


    }

</style>